export const mockPaydockServiceIds = {
  surryHills: "61e636e7a6ed826293135027",
  manly: "61e637ba5b3f054e3533a635",
  darlinghurst: "61e637fa5b3f054e3533a7c1",
};
